import { openBlock as o, createElementBlock as t, createElementVNode as r } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function l(s, e) {
  return o(), t("svg", n, [...e[0] || (e[0] = [
    r("path", {
      stroke: "currentColor",
      "stroke-width": "1.5",
      d: "m5 7.5 5 5 5-5"
    }, null, -1)
  ])]);
}
const c = { render: l };
export {
  c as default,
  l as render
};
